import { render, staticRenderFns } from "./TabbedGridPicker.vue?vue&type=template&id=944ba454"
import script from "./TabbedGridPicker.vue?vue&type=script&lang=js"
export * from "./TabbedGridPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports